import { patchUser, PatchUserInput } from '@uplift/api';
import { useQueryClient } from '@tanstack/react-query';


export const useSaveUser = () => {
  const queryClient = useQueryClient();

  const saveUser = async (userId: string, userUpdates: PatchUserInput) => {
    try {
      await patchUser(userId, userUpdates);
      await queryClient.invalidateQueries([ 'user', userId, 'basic' ]);
    } catch (error) {
      console.error(error);

      return null;
    }
  };

  return saveUser;
};
